const initialState = { isosData: [], processorsData: [], terminalMakeData: [], merchantsData: [], reportTypes: [], terminalPrefix: [], processorTerminalModels: [], processorConnections: [], processorTerminals: [], allProcessorTerminals: [], historyProcessorTerminals: [], isosForMerchantAssignment: [], merchantProcessorTerminals: [], bankStatementDescriptors: [] };

export const DROPDOWNREDUCER = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_ISOS':
            return {
                ...state,
                isosData: action.data,
            }
        case 'GET_PROCESSORS':
            return {
                ...state,
                processorsData: action.data,
            }
        case 'GET_TERMINAL_MAKE':
            return {
                ...state,
                terminalMakeData: action.data,
            }
        case 'GET_MERCHANTS':
            return {
                ...state,
                merchantsData: action.data
            }
        case 'GET_REPORT_TYPES':
            return {
                ...state,
                reportTypes: action.data
            }
        case 'GET_PREFIX':
            return {
                ...state,
                terminalPrefix: action.data
            }
        case 'GET_PROCESSOR_TERMINAL_MODELS':
            return {
                ...state,
                processorTerminalModels: action.data

            }
        case 'GET_PROCESSOR_CONNECTIONS':
            return {
                ...state,
                processorConnections: action.data
            }
        case 'GET_PROCESSOR_Terminals':
            return {
                ...state,
                processorTerminals: action.data
            }
        case 'GET_ALL_PROCESSOR_Terminals':
            return {
                ...state,
                allProcessorTerminals: action.data
            }
        case 'GET_HISTORY_PROCESSOR_Terminals':
            return {
                ...state,
                historyProcessorTerminals: action.data
            }
        case 'GET_ISOS_FOR_MERHCANT_ASSIGNMENT':
            return {
                ...state,
                isosForMerchantAssignment: action.data
            }
        case 'GET_MERCHANT_PROCESSOR_TERMINALS':
            return {
                ...state,
                merchantProcessorTerminals: action.data
            }
        case 'GET_BANK_STATEMENT_DESCRIPTORS':
            return {
                ...state,
                bankStatementDescriptors: action.data
            }    

        default:
            return state;
    }
}